import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getCookie } from '../utilities/cookies';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  
  const isAuthenticated = () => {
    const queryParameters = new URLSearchParams(window.location.search);
    const urlUserId = queryParameters.get("userId");
    
    // During SSO redirect, we consider it authenticated so the Authorize hook can process it
    if (urlUserId) return true; 

    const user = localStorage.getItem('user');
    const userId = getCookie('userId');
    const accessToken = getCookie('accessToken');
    const refreshToken = getCookie('refreshToken');
    
    // SSO Transition: if we just came from an SSO redirect, we might have cookies but no user object yet in this render cycle
    // or vice versa. We check for any valid sign of authentication.
    const hasUser = !!user && user !== 'undefined' && user !== 'null';
    const hasToken = !!userId || !!accessToken || !!refreshToken;

    return hasUser && hasToken;
  };

  if (!isAuthenticated()) {
    return <Navigate to="/signup" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;